import { LoginForm } from 'ui/components/agent/patterns/LoginForm/LoginForm';

/**
 * 仲介企業ログインページ
 */
export const AgentLogin: React.FC = () => {
    return <LoginForm />;
};
